const GET_SEARCH_RESULT = "GET_SEARCH_RESULT";
const SET_SEARCH_RESULT = "SET_SEARCH_RESULT";

const SET_SEARCHED_DATA = "SET_SEARCHED_DATA";

const SET_TABLE_DATA = "SET_TABLE_DATA";

const GET_RANDOM_LINECHART_DATA = "GET_RANDOM_LINECHART_DATA";
const SET_RANDOM_LINECHART_DATA = "SET_RANDOM_LINECHART_DATA";

const GET_LOADED_DATA = "GET_LOADED_DATA";
const SET_LOADED_DATA = "SET_LOADED_DATA";

const GET_RANDOM_CHART = "GET_RANDOM_CHART";
const SET_RANDOM_CHART = "SET_RANDOM_CHART";

const SET_SEARCH = "SET_SEARCH";

const GET_BAR_CHART_DETAILS = "GET_BAR_CHART_DETAILS";
const SET_BAR_CHART_DETAILS = "SET_BAR_CHART_DETAILS";

const GET_BAR_CHART_VALUES = "GET_BAR_CHART_VALUES";
const SET_BAR_CHART_VALUES = "SET_BAR_CHART_VALUES";

export {
  GET_SEARCH_RESULT,
  SET_SEARCH_RESULT,
  SET_SEARCHED_DATA,
  SET_TABLE_DATA,
  SET_RANDOM_LINECHART_DATA,
  GET_RANDOM_LINECHART_DATA,
  GET_LOADED_DATA,
  SET_LOADED_DATA,
  GET_RANDOM_CHART,
  SET_RANDOM_CHART,
  SET_SEARCH,
  GET_BAR_CHART_DETAILS,
  SET_BAR_CHART_DETAILS,
  GET_BAR_CHART_VALUES,
  SET_BAR_CHART_VALUES
};
